import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DepositMethodDto } from '@app/generated/models/deposit-method-dto';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserInfoDto } from '@app/generated/models/user-info-dto';
import { UserInfo } from '@app/shared/store/user-info/user-info-facade.service';
import { UserAccountControllerService } from '@app/generated/services/user-account-controller.service';
import { takeUntil } from 'rxjs/operators';
import { AccountDto } from '@app/generated/models/account-dto';
// @ts-ignore
import { of, Subject, Subscription } from 'rxjs';
import { UserDepositControllerService } from '@app/generated/services/user-deposit-controller.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-recurring-buy',
  templateUrl: './recurring-buy.component.html',
  styleUrls: ['./recurring-buy.component.scss'],
  standalone: false,
})
export class RecurringBuyComponent implements OnInit, OnDestroy {
  selectedCurrency?: string;
  paymentMethod?: DepositMethodDto;
  showRecipientInfo = false;
  depositMethodLoaded = false;
  isVerified = false;
  isBlocked = true;
  formGroup: UntypedFormGroup = new UntypedFormGroup({
    currency: new UntypedFormControl('NONE', Validators.required),
  });

  currentStep$ = of(1);

  private unsubscribe$ = new Subject<void>();
  private eventSubscription: Subscription | undefined;

  constructor(
    private depositControllerService: UserDepositControllerService,
    private accountService: UserAccountControllerService,
    private clipboard: Clipboard,
    private formBuilder: UntypedFormBuilder,
    private userInfo: UserInfo,
  ) {}

  ngOnInit() {
    this.userInfo.userInfo$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (userInfo: UserInfoDto) => {
        this.isVerified = userInfo.verificationLevel.type !== 'REGISTERED';
        this.isBlocked = userInfo.blockedDeposit || false;
      },
    });

    this.eventSubscription = this.userInfo.eventEmitter.subscribe(() => {
      this.updateDepositInfoOnAccountChange();
    });

    this.formGroup = this.formBuilder.group({
      currency: ['NONE', Validators.required],
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  updateDepositInfoOnAccountChange() {
    this.accountService
      .getActiveGuiAccountUsingGet()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((account: AccountDto) => {
        this.fetchDepositMethods(this.selectedCurrency);
      });
  }

  fetchDepositMethods(currency?: string) {
    if (!currency || currency === 'NONE') return;
    this.depositControllerService
      .getDepositMethodUsingGet({
        currencyCode: 'CZK',
        method: 'THEPAY_RECURRING',
        withQuickBuy: currency,
      })
      .subscribe((data: DepositMethodDto) => {
        this.depositMethodLoaded = true;
        this.paymentMethod = data;
      });
  }

  copyValueToClipboard(value: string) {
    this.clipboard.copy(value);
  }

  onCurrencySelected(currency: string) {
    if (currency === 'NONE') {
      this.selectedCurrency = undefined;
      this.depositMethodLoaded = false;
      this.currentStep$ = of(1);
      return;
    }

    this.selectedCurrency = currency;
    this.depositMethodLoaded = false;
    this.currentStep$ = of(3);
    this.fetchDepositMethods(currency);
  }

  protected readonly of = of;
}
